import React, {FC, useState} from "react";
import {Col, Form, Modal, notification, Row} from "antd";
import {edsResultCheck, localize} from "mixins/helpers";
import Button from "mixins/ui/button/button";
import service from "../../../services/account";
import Signature from "mixins/ui/button-signature";
import {getDataFromEcp, restorePassword, sendForgotPasswordCode} from "../actions";
import RegVerificationModal from "./reg-verification-modal";

const ForgetPassword: FC<any> = (props: any) => {
    const [openRegVerification, setOpenRegVerification] = useState(false);
    const [taxpayerCode, setTaxPayerCode] = useState<string>();
    const [signing, setSigning] = useState(false);
    const [isRestoring, setIsRestoring] = useState(false);

    const [formRegVerification] = Form.useForm();

    const getIin = (signedData) => {
        getDataFromEcp(signedData).then(
            ({ data }) => {
                const iin = edsResultCheck(data, props.translations);

                if (iin) {
                    setTaxPayerCode(iin);
                }
            }
        );
    };

    const handleForgetPassword = (xmlSigned: string) => {
        setSigning(true);

        const signedData = btoa(unescape(encodeURIComponent(xmlSigned)));

        sendForgotPasswordCode({
            signedData
        }).then(
            () => {
                setOpenRegVerification(true);
                getIin(signedData);
            }
        ).finally(
            () => setSigning(false)
        );
    };

    const getToken = () => {
        return service.getToken().then((res: any) => {
            return {
                data: `<body><text><registrationSessionToken>${res.data}</registrationSessionToken>${new Date()}</text></body>`,
            };
        });
    };

    const closeRegVerificationModal = () => {
        setOpenRegVerification(false);
        formRegVerification.resetFields();
    };

    const handleRegVerification = () => {
        formRegVerification.validateFields().then(
            () => {
                const { confirmCode, newPassword, repeatPassword } = formRegVerification.getFieldsValue();

                setIsRestoring(true);

                restorePassword({
                    confirmCode,
                    newPassword,
                    repeatPassword,
                    taxpayerCode
                }).then(
                    () => {
                        props.close();
                        closeRegVerificationModal();

                        notification['success']({
                            message: localize('block-auth-password-successfully-reset', props.translations),
                            description: localize('block-auth-please-try-logging', props.translations),
                        })
                    }
                ).finally(
                    () => setIsRestoring(false)
                );
            }
        );
    };

    return (
        <>
            <Modal
                open={props.open}
                onCancel={props.close}
                footer={
                    <Row justify="end" gutter={15} className="pt-3">
                        <Col>
                            <Signature
                                onGetXml={getToken}
                                onSubmit={handleForgetPassword}
                                loading={signing}
                                icon
                                translations={props.translations}
                            />
                        </Col>
                        <Col>
                            <Button onClick={props.close}>
                                {localize("button.close", props.translations)}
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <div className="my-3">
                    <h5>{localize('block-auth-password-sent-email', props.translations)}</h5>
                </div>
            </Modal>

            <RegVerificationModal
                open={openRegVerification}
                close={closeRegVerificationModal}
                onOk={handleRegVerification}
                translations={props.translations}
                form={formRegVerification}
                reset={true}
                isRestoring={isRestoring}
            />
        </>
    );
};

export default ForgetPassword;
